export const initializeAnalytics = () => {
	const emailLinks = document.querySelectorAll('a[href^="mailto:"]');
	if (emailLinks?.length) {
		emailLinks.forEach(emailLink => {
		  	emailLink.addEventListener('click', function(event) {
		    	sendAnalyticsEvent('email_click', {
			      	event_category: 'Contact',
			      	event_label: event.target.href.replace("mailto:", "")
			    });
		  	});
		});
	}

	const allForms = document.querySelectorAll('form:not(.js-cm-form)');

	if (allForms?.length) {
		allForms.forEach(form => {
			form.addEventListener('submit', (e) => {
			    e.preventDefault(); // prevent instant redirect

			    sendAnalyticsEvent('form_submission', {
			     	event_category: 'Forms',
			      	event_label: form.id
			    });

			    // Submit the form after short delay to ensure GA event is sent
			    setTimeout(() => {
			      	form.submit();
			    }, 300);
			});
		});
	}
};

function sendAnalyticsEvent(eventName, eventParams) {
    if (typeof window.gtag !== 'function') {
        return;
    }

    window.gtag('event', eventName, eventParams);
}
